import React from 'react';
import { StaticImageData } from 'next/image';

import ArrowLink, { ArrowLinkButtonProps } from 'Elements/Button/Arrow';
import Grid, { Col } from 'Components/Grid';

import {
    Wrapper,
    Container,
    StyledNextImageDesktop,
    StyledNextImageDevice,
    Heading,
    PostHeading
} from './Home.styled';

export interface Props {
    heading: string;
    postHeading?: string;
    images: {
        desktop: {
            src: string | StaticImageData;
            alt?: string;
        };
        device: {
            src: string | StaticImageData;
            alt?: string;
        };
    };
    link: ArrowLinkButtonProps;
}

const Home: React.FC<Props> = ({ heading, postHeading, images, link }) => {
    return (
        <Wrapper>
            <StyledNextImageDesktop
                src={images.desktop.src}
                alt={images.desktop.alt ? images.desktop.alt : ''}
                fill
                loading="eager"
                priority
                quality={100}
                className="next-image"
            />
            <StyledNextImageDevice
                src={images.device.src}
                alt={images.device.alt ? images.device.alt : ''}
                fill
                loading="eager"
                priority
                quality={100}
                className="next-image"
            />
            <div>
                <Grid>
                    <Col b={9} s={8} sl={7} m={6}>
                        <Container>
                            <Heading>{heading}</Heading>
                            <PostHeading>{postHeading}</PostHeading>
                        </Container>
                    </Col>
                    <Col sl={9} m={[1, 7]} l={[1, 6]}>
                        <ArrowLink {...link} />
                    </Col>
                </Grid>
            </div>
        </Wrapper>
    );
};

export default Home;
